/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 */

import { withTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import compose from 'utils/compose';

import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { withStyles } from 'tss-react/mui';

import PiggyBank from 'assets/illustrations/404.png';
import ReportProblemLink from 'components/ReportProblemLink';

const styles = () => ({
  root: {
    width: 940,
    margin: 'auto',
    marginTop: 50,
    marginBottom: 50,
    padding: 80,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
});

class NotFound extends PureComponent {
  // eslint-disable-line react/prefer-stateless-function
  static propTypes = {
    classes: PropTypes.object,
    theme: PropTypes.object,
  };

  render() {
    const { classes, theme } = this.props;
    return (
      <>
        <Helmet>
          <title>Page Not Found</title>
          <meta name='description' content='Page Not Found' />
        </Helmet>

        <Paper className={classes.root}>
          <img alt='upside down piggy bank' src={PiggyBank} style={{ margin: '40px auto', width: '446px' }} />
          <Typography variant='displayRegular' style={{ color: theme.palette.text.primary }}>
            OOPS!
          </Typography>
          <Typography variant='paragraphRegular'>Error Code 404</Typography>
          <Typography variant='titleMedium'>
            We can&apos;t seem to find <br /> the page you&apos;re looking for.
          </Typography>
          <Link to='/' style={{ textDecoration: 'none' }}>
            <Button variant='contained' color='primary' style={{ margin: 20 }}>
              Return to Dashboard
            </Button>
          </Link>

          <ReportProblemLink feedbackSubject='report page not found' />
        </Paper>
      </>
    );
  }
}

export const Component = compose(withTheme)(withStyles(NotFound, styles));
export default Component;
